isFreeShippingOnSub = false;
ACDiscountAppSubTotal.CartPage.Show_CalculateTier = function () {
    
    var UpdateCartItem = function (item, updatedItemPrice, updatedLinePrice, isUpdate, index) {
        if (isUpdate) {
            var originalItemPrice = globalFieldsSubtotal.ConvertToFixedDecimalNumber(item.original_price / 100),
                originalLinePrice = globalFieldsSubtotal.ConvertToFixedDecimalNumber(item.original_line_price / 100);
            var condition1 = updatedItemPrice == originalItemPrice;
            (updatedItemPrice = globalFieldsSubtotal.ConvertToFixedDecimalString(updatedItemPrice)),
                (updatedLinePrice = globalFieldsSubtotal.ConvertToFixedDecimalString(updatedLinePrice));
            if (condition1) {
            } else {
                (originalItemPrice = globalFieldsSubtotal.ConvertToFixedDecimalString(originalItemPrice)),
                    (originalLinePrice = globalFieldsSubtotal.ConvertToFixedDecimalString(originalLinePrice));
            }
        }
    };
    var UpdateCartSubtotal = function (isUpdate, updatedTotalPrice, originalTotalPrice) {
        if (isUpdate) {
            (updatedTotalPrice = globalFieldsSubtotal.ConvertToFixedDecimalString(updatedTotalPrice)),
                (originalTotalPrice = globalFieldsSubtotal.ConvertToFixedDecimalString(originalTotalPrice));
            if (originalTotalPrice != updatedTotalPrice) {
            } else {
            }
        }
    };
    var UpdateSavingMessage = function (isUpdate) {
        if (priceDiff > 0 && isUpdate && globalFieldsSubtotal.isCartPage) {
            var saveMessage = globalFieldsSubtotal.settings.cart_saving_message.replace(
                "{{discount_amount}}",
                '<span class="money" data-currency-' +
                    globalFieldsSubtotal.currency.toLowerCase() +
                    '="' +
                    globalFieldsSubtotal.currencySymbol +
                    priceDiff.toFixed(2) +
                    '" data-currency="' +
                    globalFieldsSubtotal.currency +
                    '">' +
                    globalFieldsSubtotal.formatMoney(priceDiff.toFixed(2), globalFieldsSubtotal.amount) +
                    "</span>"
            );
            var saveHtml = '<span id="saved-banner">' + saveMessage + "</span>";
            if (jQuery(window).width() < 700) {
            } else {
            }
        } else if (globalFieldsSubtotal.isCartPage) {
            jQuery("#saved-banner-div").remove();
        }
    };
    var CheckoutClickCart = function () {
        jQuery('.cart__footer .cart__ctas button[name="checkout"]').click(function () {
            TieredPricingCart(globalFieldsSubtotalCartPage_AC.cartObj, !1);
        });
    };
    var CheckoutClickAjax = function () {
        jQuery('.drawer__footer .cart__ctas button[name="checkout"]').click(function (e) {
            e.preventDefault();
        });
    };
    var GetCode = function (isUpper) {
        if (priceDiff > 0) {
            jQuery.ajax({
                type: "POST",
                async: !1,
                url: "https://customerapp.anncode.com/tier/ACPGenerateCartCode",
                data: { discountOff: priceDiff, subTotal: minimumDiscountSubtotal, discounType: "fixed_amount" },
                success: function (result) {
                    try {
                        if (result.status != "error" || result.DiscountCode) {
                            var data_ = JSON.stringify(result);
                            var parsed_data = JSON.parse(data_);
                            var PRID = parsed_data.PRID;
                            var DCID = parsed_data.DCID;
                            var DiscountCode = parsed_data.DiscountCode;
                            SetCookie("discountCodes", PRID + "-" + DCID + "-" + DiscountCode, 30);
                            if (!isUpper) {
                                DiscountCodeCookie(DiscountCode);
                                jQuery('form[action="/cart"]').append(
                                    '<input id="discount_input" type="hidden" name="discount" value="' +
                                        DiscountCode +
                                        '">'
                                );
                            } else {
                                DiscountCodeCookie(DiscountCode);
                                window.location.href = "/checkout?discount=" + DiscountCode;
                            }
                        } else {
                            window.location.href = "/checkout";
                        }
                    } catch (e) {
                        console.log(e);
                    }
                },
                error: function (e) {
                    console.log(e.statusText);
                },
            });
        } else if (isUpper) {
            window.location.href = "/checkout";
        }
    };
    var ReInvokeAjaxCartButton = function () {
        jQuery(".mb_cart.mb_item button.btn, .top-header .dropdown-cart button.btn").off("click");
        CheckoutClickAjax();
    };
    var variantIdsToSend = [],
        minimumDiscountSubtotal = 0,
        priceDiff = 0;
    var TieredPricingCart = function (cartObject, isUpdate) {
       isCartCheckOutBtn = true
       isFreeShippingOnSub = false;
        makeEnableDisablebtn()
        variantIdsToSend = [];
        minimumDiscountSubtotal = 0;
        priceDiff = 0;
        var updatedTotalPrice = 0;
        var actualTotalPrice = 0;
        var tierObj = globalFieldsSubtotalCartPage_AC.cartSubTotalMetafield;
        let DiscountAppliedOnTag = !0;
        if (tierObj != undefined && tierObj != "[]") {
            DiscountAppliedOnTag =
                tierObj.DiscountAppliedON != undefined
                    ? tierObj.DiscountAppliedON == "Both_Store" || tierObj.DiscountAppliedON == "Online_Store"
                        ? !0
                        : !1
                    : !1;
        } else {
            DiscountAppliedOnTag = !1;
        }
        if (
            tierObj != undefined &&
            tierObj != "[]" &&
            tierObj.status &&
            DiscountAppliedOnTag &&
            globalFieldsSubtotal.StartEndDateValid(tierObj.start_date, tierObj.end_date)
        ) {
            var calculatedTier = CalculateTierCartSubTotal(
                tierObj,
                globalFieldsSubtotalCartPage_AC.is_quantity_total,
                !0
            );
            if (!calculatedTier[3]) {
                for (k = 0; k < globalFieldsSubtotalCartPage_AC.cartTiersArray.length; k++) {
                    var item = globalFieldsSubtotalCartPage_AC.cartTiersArray[k];
                    actualTotalPrice += globalFieldsSubtotal.ConvertToFixedDecimalNumber(
                        item.item.original_line_price / 100
                    );
                    if (!item.is_exclude) {
                        variantIdsToSend.push(item.item.variant_id);
                    }
                    if (tierObj.discount_type == "percentage") {
                        var rslt = CalculateTier(item.item, calculatedTier[2], tierObj, isUpdate, k);
                    }
                }
                minimumDiscountSubtotal = actualTotalPrice;
                updatedTotalPrice = actualTotalPrice - calculatedTier[5];
                UpdateCartSubtotal(
                    isUpdate,
                    globalFieldsSubtotal.ConvertToFixedDecimalNumber(updatedTotalPrice),
                    globalFieldsSubtotal.ConvertToFixedDecimalNumber(actualTotalPrice)
                );
                priceDiff = calculatedTier[5];
                localStorage.setItem("subtotal_discount_amount", `${calculatedTier[2]}`);
                localStorage.setItem("subtotal_discount_type", tierObj.discount_type);
                UpdateSavingMessage(isUpdate);
            }
        }
        // setDateTimeInCart();
        // setTimeout(function () {
            setDateTimeInCart();
        // }, 1000);
    };
    var CalculateTierCartSubTotal = function (tiers, is_quantity_total, isNotInRange) {
        var eligibleItems = jQuery.grep(globalFieldsSubtotalCartPage_AC.cartTiersArray, function (n) {
            return !n.is_exclude;
        });
        var allVariantItemQty = 0;
        var eligibleSubtotal = 0;
        var discount_total = 0;
        for (j = 0; j < eligibleItems.length; j++) {
            allVariantItemQty += eligibleItems[j].item.quantity;
            eligibleSubtotal += globalFieldsSubtotal.ConvertToFixedDecimalNumber(
                eligibleItems[j].item.original_line_price / 100
            );
        }
        var tierPrice = 0,
            minTier = 0,
            maxTier = "";
        for (i = 0; i < tiers.tier_min.length; i++) {
            tierPrice = parseFloat(tiers.tier_values[i]);
            (minTier = Number(tiers.tier_min[i])),
                (maxTier = tiers.tier_max[i] != "max" ? Number(tiers.tier_max[i]) : tiers.tier_max[i]);
            var condition1 = !1,
                condition2 = !1;
            let requiredsubTotalOrQuantity;
            if (is_quantity_total) {
                condition1 = allVariantItemQty >= minTier;
                condition2 = maxTier == "max" || allVariantItemQty <= maxTier;
                requiredsubTotalOrQuantity = allVariantItemQty;
            } else {
                condition1 = eligibleSubtotal >= minTier;
                condition2 = maxTier == "max" || eligibleSubtotal <= maxTier;
                requiredsubTotalOrQuantity = eligibleSubtotal;
            }
            if (condition1 && condition2) {
                CalculateProgreBarTierCartSubTotal(requiredsubTotalOrQuantity, is_quantity_total);
                isFreeShippingOnSub = true;
                isNotInRange = !1;
                if (tiers.discount_type == "percentage") {
                    discount_total = parseFloat(
                        globalFieldsSubtotal.ConvertToFixedDecimalNumber(
                            (parseFloat(tierPrice) / 100) *
                                globalFieldsSubtotal.ConvertToFixedDecimalNumber(eligibleSubtotal)
                        )
                    );
                } else if (tiers.discount_type == "fixed") {
                    discount_total = globalFieldsSubtotal.ConvertToFixedDecimalNumber(parseFloat(tierPrice));
                }
                break;
            }
            if (!condition1) {

                if (requiredsubTotalOrQuantity < tiers.tier_min[0] && tiers.tier_min.length > 1) {
                    var getTierObj = tierObjCalculations(!0);
                    spandMessageForBar(getTierObj[0], 0, requiredsubTotalOrQuantity, !1);
                     updateBarTier(getTierObj[0],is_quantity_total);
                }
            }
        }
        return [minTier, maxTier, tierPrice, isNotInRange, eligibleSubtotal, discount_total];
    };
    var CalculateTier = function (item, tierPrice, itemTiers, isUpdate, index) {
        var updatedItemPrice = 0,
            updatedLinePrice = 0;
        if (itemTiers.discount_type == "percentage") {
            var originalPriceCut = parseFloat(
                globalFieldsSubtotal.ConvertToFixedDecimalNumber(
                    (parseFloat(tierPrice) / 100) *
                        globalFieldsSubtotal.ConvertToFixedDecimalNumber(item.original_price / 100)
                )
            );
            updatedItemPrice = globalFieldsSubtotal.ConvertToFixedDecimalNumber(
                globalFieldsSubtotal.ConvertToFixedDecimalNumber(item.original_price / 100) - originalPriceCut
            );
        }
        if (updatedItemPrice < 0) {
            updatedItemPrice = 0;
        }
        updatedLinePrice = globalFieldsSubtotal.ConvertToFixedDecimalNumber(updatedItemPrice * item.quantity);
        UpdateCartItem(item, updatedItemPrice, updatedLinePrice, isUpdate, index);
    };
    var DiscountCodeCookie = function (discount_code) {
        jQuery.ajax({
            type: "HEAD",
            url: "/discount/" + discount_code,
            success: function (_result) {},
            error: function (e) {
                console.log(e.statusText);
            },
        });
    };
    var FetchCartTiers = function () {
        let drawerBarHtml;
        jQuery.ajax({
            async: !1,
            url: "/cart/?view=ac_cart_subtotal_tiers",
            success: function (result) {
                setTimeout(async function () {
                    drawerBarHtml = localStorage.getItem("drawerBarHtml");
                    jQuery(".ac-CartDrawer-bar").html(drawerBarHtml);
                    cartBarHtml = localStorage.getItem("cartBarHtml");
                    jQuery(".ac-Cart-bar").html(cartBarHtml);
                    
                            if (globalFieldsSubtotalCartPage_AC.cartObj.items.length == 0) {
                            jQuery('.CartDrawer').remove()
                            jQuery('.mainCartDiscount').remove()
                            
                        }
                    isFreeShippingOnSub = false;
                    globalFieldsSubtotalCartPage_AC.cartTiersArray = JSON.parse(result);
                    TieredPricingCart(globalFieldsSubtotalCartPage_AC.cartObj, !0);
                }, 900);
            },
            error: function (e) {
                console.log(e.statusText);
            },
        });
    };
    jQuery(document).ajaxComplete(function (event, xhr, settings) {
        if (settings && settings.url) {
            ProcessCartResponse(settings.url, xhr.responseText);
        }
    });
    try {
        var nativeFetch = window.fetch;
        var isUpdatingCart = !1;
        window.fetch = function (...args) {
            try {
                if (
                    typeof args[0] === "string" &&
                    (args[0].includes("/cart/change") || args[0].includes("/cart/add"))
                ) {
                    if (!isUpdatingCart) {
                        isCartCheckOutBtn = true
                        makeEnableDisablebtn()
                        isUpdatingCart = !0;
                        setTimeout(async function () {
                            fetch("/cart.js")
                                .then((r) => r.json().then((data) => ({ status: r.status, body: data })))
                                .then((obj) => ProcessCartResponse("/cart.js", JSON.stringify(obj.body)));
                            isUpdatingCart = !1;
                        }, 800);
                    }
                }
            } catch (err) {
                console.error("Error in intercepting fetch:", err);
            }
            return nativeFetch?.apply(window, args);
        };
    } catch (e) {
        console.error("Error in overriding fetch:", e);
    }
    var ProcessCartResponse = function (splittedUrl, responseText) {
        if (splittedUrl != "undefined" && splittedUrl != "" && splittedUrl != null) {
            splittedUrl = splittedUrl.split("?");
            if ((splittedUrl[0] == "/cart.js" || splittedUrl[0] == "/cart/change.js" || splittedUrl[0] == "/cart/update.js") &&( responseText && responseText.includes('"token":') )  ) {
                var data_cart_obj = JSON.parse(responseText);
                if (data_cart_obj.status != "422") {
                    isCartCheckOutBtn = true
                    makeEnableDisablebtn()
                    globalFieldsSubtotalCartPage_AC.cartObj = JSON.parse(responseText);
                }
                setTimeout(function () {
                    FetchCartTiers();
                }, 800);
                if (splittedUrl[0] == "/cart/change.js") {
                    setTimeout(function () {
                    FetchCartTiers();
                }, 500);
                }

            }
        }
    };
    function addProgresbarHtml() {
        if (globalFieldsSubtotalCartPage_AC.cartObj.items.length == 0) {
            jQuery('.CartDrawer').remove()
            jQuery('.mainCartDiscount').remove()
            return
        }
        let finalHtml = "";
        let cartBarHtml = "";
        let drawerBarHtml = "";
        var getTierObj = tierObjCalculations(!0);
        var tierObj = getTierObj[0];
          let alignLeft = '65px'
            if (window.innerWidth <= 768) {
            alignLeft= '25px';
            } else {
            alignLeft = '65px';
            }

        if (tierObj.tier_min.length == 1) {
            cartBarHtml += ` <div class="main mainCartDiscount" style="margin-top: 0px; width: 100%;margin-bottom: 15px;"><div class="mainCart"><p class="ac-main-paragraphCart" style="
                width: 90%;
                color:rgb(18, 10, 8);
                font-size: 11px;
                font-weight: 700;
                margin-left:${alignLeft};
                "></p> <div class="progr" style="
                margin: auto;
                / background: red; /
                width: 80%;
                ">`;
            drawerBarHtml += ` <div class="CartDrawer main" style="margin-top: 0px;margin-bottom: 31px;width: 100%;font-family: &quot;Helvetica&quot;, &quot;Helvetica Neue&quot;, Arial, sans-serif;font-size: 11px;"><div class="mainCart"><p class="ac-main-paragraphCart" style="
                width: 90%;
                font-weight: 500;
                //font-weight: bold;
                font-size: 11px;
                color: rgb(237, 111, 81);
                margin-left: 25px;
                "></p> <div class="progr" style="
                margin: auto;
                / background: red; /
                width: 80%;
                ">`;
            cartBarHtml += `<p class="cartDiscountMessage">${tierObj.discountTitle}<p>`;
            drawerBarHtml += `<p class="DrawerDiscountMessage" >${tierObj.discountTitle}<p>`;
            cartBarHtml += `</div>`;
            drawerBarHtml += `</div></div></div>`;

            
            if (globalFieldsSubtotal.isCartPage) {
              let Cart = jQuery(".ac-Cart-bar")
                if (Cart) {
                 jQuery(".ac-Cart-bar").html(cartBarHtml);
                }else{
                  jQuery(".cart-wrapper.cart-wrapper--compact .cart-header").after(cartBarHtml);
                }
            } else {
                let CartDrawer = jQuery(".ac-CartDrawer-bar")
                if (CartDrawer) {
                     jQuery(".ac-CartDrawer-bar").html(drawerBarHtml);
                }else{
                    jQuery("#CartDrawer .drawer__heading").after(drawerBarHtml);

                }
            }
            localStorage.setItem("drawerBarHtml", drawerBarHtml);
            localStorage.setItem("cartBarHtml", cartBarHtml);
            jQuery(".ac-CartDrawer-bar").html(drawerBarHtml);
            jQuery(".ac-Cart-bar").html(drawerBarHtml);
        } else {
            cartBarHtml += ` <div class="main mainCartDiscount" style="margin-top: 0px; width: 100%;margin-bottom: 10px;"><div class="mainCart"><p class="ac-main-paragraphCart" style="
            width: 90%;
            margin-bottom: 40px;
            color:rgb(16, 7, 4);
            / background-color: red; /
            //font-weight: bold;
            font-size: 11px;
            font-weight: 500;
            margin-left:${alignLeft};
            "></p> <div class="progr" style="
            margin: auto;
            / background: red; /
            width: 80%;
            "><ul class="ac-main-listCart">`;
            drawerBarHtml += ` <div class="CartDrawer main" style="margin-top: 0px;margin-bottom: 31px;width: 100%;font-family: &quot;Helvetica&quot;, &quot;Helvetica Neue&quot;, Arial, sans-serif;font-size: 11px;"><div class="mainCart"><p class="ac-main-paragraphCart" style="
            width: 90%;
            margin-bottom: 50px;
            font-weight: 500;
            //font-weight: bold;
            font-size: 11px;
            color: rgb(6, 4, 3);
            margin-left: 25px;
            "></p> <div class="progr" style="
            margin: auto;
            / background: red; /
            width: 80%;
            "><ul class="ac-main-listCart">`;
            for (let i = 0; i < tierObj.tier_min.length; i++) {
                let tierValue =
                tierObj.discount_type == "percentage" ? `${tierObj.tier_values[i]}%`: `Save ${globalFieldsSubtotal.formatMoney(tierObj.tier_values[i] * 100, globalFieldsSubtotal.amount)}`;
                if (i == tierObj.tier_min.length - 1) {
                    finalHtml = createBarHtml("first", tierValue, "barHtml", tierObj.discount_type);
                } else {
                    finalHtml = createBarHtml("", tierValue, "barHtml", tierObj.discount_type);
                }
                cartBarHtml += finalHtml[0];
                drawerBarHtml += finalHtml[1];
            }
            cartBarHtml += `</ul></div>`;
            drawerBarHtml += `</ul></div></div> </div>`;
            if (globalFieldsSubtotal.isCartPage) {
                let Cart = jQuery(".ac-Cart-bar")
                if (Cart) {
                jQuery(".ac-Cart-bar").html(cartBarHtml);
                }else{
               jQuery(".cart-wrapper.cart-wrapper--compact .cart-header").after(cartBarHtml);
                }
            } else {
                let CartDrawer = jQuery(".ac-CartDrawer-bar")
                if (CartDrawer) {
                     jQuery(".ac-CartDrawer-bar").html(drawerBarHtml);
                }else{
                    jQuery("#CartDrawer .drawer__heading").after(drawerBarHtml);

                }
            }
            localStorage.setItem("drawerBarHtml", drawerBarHtml);
            localStorage.setItem("cartBarHtml", cartBarHtml);
            jQuery(".ac-CartDrawer-bar").html(drawerBarHtml);
            jQuery(".ac-Cart-bar").html(cartBarHtml);
        }
    }
    function createBarHtml(spendOrClassName, tierValueOrGetAmount, barHtmlOrItem, valueSet, messageChanges = !1) {
        if (barHtmlOrItem == "barHtml") {
            let cartBarHtml;
            let drawerBarHtml;
            let alignLeft = '158px'
            if (window.innerWidth <= 768) {
            alignLeft= '24px';
            } else {
            alignLeft = '158px';
            }

            cartBarHtml = `<li class="ac-main-list-item-Cart"><i class="icons-Cart awesome-Cart "></i><div class="ac-step-Cart ${spendOrClassName}-Cart barCounts-Cart"><p class="ac-step-count-Cart" ></p><i class="awesome-Cart fa-solid fa-check"></i></div><p class="ac-label-Cart ac-label-cart-discount"> <div style="top: 20px;position: relative;left: ${alignLeft};font-size: 11px;">${tierValueOrGetAmount}</div></p></li> `;
            drawerBarHtml = `<li class="ac-main-list-item-Cart"><i class="icons-Cart awesome-Cart "></i><div class="ac-step-Cart ${spendOrClassName}-Cart barCounts-Drawer"><p class="ac-step-count-Cart" ></p><i class="awesome-Cart fa-solid fa-check"></i></div><p class="ac-label-Cart ac-label-Drawer"><div style=" left: 35px; top: 12px;position: relative;">${tierValueOrGetAmount}</div></p></li> `;
            return [cartBarHtml, drawerBarHtml];
        } else if (barHtmlOrItem == "items" || barHtmlOrItem == "") {
            if (valueSet == "percentage") {
                cartBarHtml = `Add ${spendOrClassName} to unlock secret offer`;
                drawerBarHtml = `Add ${spendOrClassName} to unlock secret offer`;
            } else {
                if (messageChanges) {
                    cartBarHtml = `Congratulation, you've just saved ${globalFieldsSubtotal.formatMoney(messageChanges*100, globalFieldsSubtotal.amount)} Add ${spendOrClassName} more to save ${tierValueOrGetAmount}`;
                    drawerBarHtml = `Congratulation, you've just saved ${globalFieldsSubtotal.formatMoney(messageChanges*100, globalFieldsSubtotal.amount)} Add ${spendOrClassName} more to save ${tierValueOrGetAmount}`;
                } else {
                    cartBarHtml = `Add ${spendOrClassName} more to save ${tierValueOrGetAmount}`;
                    drawerBarHtml = `Add ${spendOrClassName} more to save ${tierValueOrGetAmount}`;
                }
            }
            return [cartBarHtml, drawerBarHtml];
        } else {
            cartBarHtml = `🎉 You’re saving ${tierValueOrGetAmount}`;
            drawerBarHtml = `🎉 You’re saving ${tierValueOrGetAmount}`;
            return [cartBarHtml, drawerBarHtml];
        }
    }
    function CalculateProgreBarTierCartSubTotal(requiredsubTotalOrQuantity, is_quantity_total) {
        let tierForBarfun = tierObjCalculations(!1);
        let tierForBar = tierForBarfun[0];
         updateBarTier(tierForBar,is_quantity_total);
        var tierPrice = 0,
            minTier = 0,
            maxTier = "";
                    if (tierForBar.tier_min.length == 1) return
        for (i = 0; i < tierForBar.tier_min.length; i++) {
            tierPrice = parseFloat(tierForBar.tier_values[i]);
            (minTier = Number(tierForBar.tier_min[i])),
                (maxTier = tierForBar.tier_max[i] != "max" ? Number(tierForBar.tier_max[i]) : tierForBar.tier_max[i]);
            var condition1 = !1,
                condition2 = !1;
            if (is_quantity_total) {
                condition1 = requiredsubTotalOrQuantity >= minTier;
                condition2 = maxTier == "max" || requiredsubTotalOrQuantity <= maxTier;
            } else {
                condition1 = requiredsubTotalOrQuantity >= minTier;
                condition2 = maxTier == "max" || requiredsubTotalOrQuantity <= maxTier;
            }
            if (condition1 && condition2) {
                nextTierofDiscount(i, tierForBarfun[1]);
                spandMessageForBar(tierForBar, i, requiredsubTotalOrQuantity, !0);
                break;
            }
            if (!condition1) {
            }
        }
    }
    function nextTierofDiscount(currentStep, zeroIndexTier) {
        let barCountsCart;
        barCountsCart = document.querySelectorAll(".barCounts-Cart");
        barCountsCart.forEach((step) => step.classList.remove("active-Cart"));
        barCountsCart.forEach((step, index) => {
            if (index <= currentStep) {
                step.classList.add("active-Cart");
                step.style.width = `${100}%`;
            } else {
                step.classList.remove("active-Cart");
            }
        });
        let barCountsDrawer;
        barCountsDrawer = document.querySelectorAll(".barCounts-Drawer");
        barCountsDrawer.forEach((step) => step.classList.remove("active-Drawer"));
        barCountsDrawer.forEach((step, index) => {
            if (index <= currentStep) {
                step.classList.add("active-Drawer");
            } else {
                step.classList.remove("active-Drawer");
            }
        });
    }
    function spandMessageForBar(tiers, i, requiredsubTotalOrQuantity, isNotInRange) {
        let encourageMessageOnSpendCart = jQuery(".ac-main-paragraphCart");
        let encourageMessageOnSpendDrawer = jQuery(".ac-main-paragraphDrawer");
        encourageMessageOnSpendCart.text("");
        encourageMessageOnSpendDrawer.text("");
        let differenceAmountOrQuantity;
        let getNextTier;
        let FinalEncourageMessage;
        let t = tiers.tier_values[i + 1] !== undefined;
        if (tiers.tier_values[i + 1] !== undefined && isNotInRange) {
            var messageChanges = tiers.tier_values[i];
            if (tiers.DiscountBasedOn == "Range of Quantities") {
                const differenceAmountOrQuantity = tiers.tier_min[i + 1] - requiredsubTotalOrQuantity;
                const getNextTier =
                    tiers.discount_type === "percentage"
                        ? `${tiers.tier_values[i + 1]}%`
                        : globalFieldsSubtotal.formatMoney(tiers.tier_values[i + 1] * 100, globalFieldsSubtotal.amount);
                FinalEncourageMessage = createBarHtml(
                    differenceAmountOrQuantity,
                    getNextTier,
                    "items",
                    tiers.discount_type,
                    messageChanges
                );
                encourageMessageOnSpendCart = FinalEncourageMessage[0];
                encourageMessageOnSpendDrawer = FinalEncourageMessage[1];
            } else {
                const differenceAmountOrQuantity = globalFieldsSubtotal.formatMoney(
                    (tiers.tier_min[i + 1] - requiredsubTotalOrQuantity) * 100,
                    globalFieldsSubtotal.amount
                );
                const getNextTier =
                    tiers.discount_type === "percentage"
                        ? `${tiers.tier_values[i + 1]}`
                        : globalFieldsSubtotal.formatMoney(tiers.tier_values[i + 1] * 100, globalFieldsSubtotal.amount);
                FinalEncourageMessage = createBarHtml(
                    differenceAmountOrQuantity,
                    getNextTier,
                    "",
                    tiers.discount_type,
                    messageChanges
                );
                encourageMessageOnSpendCart = FinalEncourageMessage[0];
                encourageMessageOnSpendDrawer = FinalEncourageMessage[1];
            }
        } else {
            if (isNotInRange) {
                if (tiers.DiscountBasedOn == "Range of Quantities") {
                    const differenceAmountOrQuantity = tiers.tier_min[i] - requiredsubTotalOrQuantity;
                    const getNextTier =
                        tiers.discount_type === "percentage"
                            ? `${tiers.tier_values[i]}%`
                            : globalFieldsSubtotal.formatMoney(tiers.tier_values[i] * 100, globalFieldsSubtotal.amount);
                    FinalEncourageMessage = createBarHtml("", getNextTier, "saving", tiers.discount_type);
                    encourageMessageOnSpendCart = FinalEncourageMessage[0];
                    encourageMessageOnSpendDrawer = FinalEncourageMessage[1];
                } else {
                    const differenceAmountOrQuantity = globalFieldsSubtotal.formatMoney(
                        (tiers.tier_min[i] - requiredsubTotalOrQuantity) * 100,
                        globalFieldsSubtotal.amount
                    );
                    const getNextTier =
                        tiers.discount_type === "percentage"
                            ? `${tiers.tier_values[i]}%`
                            : globalFieldsSubtotal.formatMoney(tiers.tier_values[i] * 100, globalFieldsSubtotal.amount);
                    FinalEncourageMessage = createBarHtml("", getNextTier, "saving", tiers.discount_type);
                    encourageMessageOnSpendCart = FinalEncourageMessage[0];
                    encourageMessageOnSpendDrawer = FinalEncourageMessage[1];
                }
            } else {
                if (tiers.DiscountBasedOn == "Range of Quantities") {
                    const differenceAmountOrQuantity = tiers.tier_min[i] - requiredsubTotalOrQuantity;
                    const getNextTier =
                        tiers.discount_type === "percentage"
                            ? `${tiers.tier_values[i]}%`
                            : globalFieldsSubtotal.formatMoney(tiers.tier_values[i] * 100, globalFieldsSubtotal.amount);
                    FinalEncourageMessage = createBarHtml(
                        differenceAmountOrQuantity,
                        getNextTier,
                        "items",
                        tiers.discount_type
                    );
                    encourageMessageOnSpendCart = FinalEncourageMessage[0];
                    encourageMessageOnSpendDrawer = FinalEncourageMessage[1];
                } else {
                    let djd = tiers.tier_min[i] - requiredsubTotalOrQuantity;
                    const differenceAmountOrQuantity = globalFieldsSubtotal.formatMoney(
                        (tiers.tier_min[i] - requiredsubTotalOrQuantity) * 100,
                        globalFieldsSubtotal.amount
                    );
                    const getNextTier =
                        tiers.discount_type === "percentage"
                            ? `${tiers.tier_values[i]}%`
                            : globalFieldsSubtotal.formatMoney(tiers.tier_values[i] * 100, globalFieldsSubtotal.amount);
                    FinalEncourageMessage = createBarHtml(
                        differenceAmountOrQuantity,
                        getNextTier,
                        "",
                        tiers.discount_type
                    );
                    encourageMessageOnSpendCart = FinalEncourageMessage[0];
                    encourageMessageOnSpendDrawer = FinalEncourageMessage[1];
                }
            }
        }
        if (tiers.tier_min.length > 1) {
            jQuery(".ac-main-paragraphDrawer").text(encourageMessageOnSpendDrawer);
            jQuery(".ac-main-paragraphCart").text(encourageMessageOnSpendCart);
        }
    }
    function tierObjCalculations(isPageLoad) {
        var tierForBar = globalFieldsSubtotalCartPage_AC.cartSubTotalMetafield;
        let tierObj = { ...tierForBar };
        var eligibleItems = jQuery.grep(globalFieldsSubtotalCartPage_AC.cartTiersArray, function (n) {
            return !n.is_exclude;
        });
        let total = 0;
        var discount_total = 0;
        for (j = 0; j < eligibleItems.length; j++) {
            if (tierObj.DiscountBasedOn == "Range of Quantities") {
                total += eligibleItems[j].item.quantity;
            } else {
                total += globalFieldsSubtotal.ConvertToFixedDecimalNumber(
                    eligibleItems[j].item.original_line_price / 100
                );
            }
        }
        let position = 0;
        let zeroIndexTier = !1;
        if (tierObj.tier_min.length >= 5) {
            if (total < tierObj.tier_min[0]) {
                position = 0;
                zeroIndexTier = !1;
            } else if (total >= tierObj.tier_min[tierObj.tier_min.length - 1]) {
                position = tierObj.tier_min.length - 1;
                zeroIndexTier = !1;
            } else {
                for (let i = 0; i < tierObj.tier_min.length; i++) {
                    if (
                        total >= tierObj.tier_min[i] &&
                        (tierObj.tier_max[i] == "max" || total <= tierObj.tier_max[i])
                    ) {
                        position = i;
                        zeroIndexTier = !1;
                        break;
                    }
                }
            }
            tierObj.tier_min =
                tierObj.tier_min.length - position >= 5
                    ? tierObj.tier_min.slice(position, position + 5)
                    : tierObj.tier_min.slice(-5);
            tierObj.tier_max =
                tierObj.tier_max.length - position >= 5
                    ? tierObj.tier_max.slice(position, position + 5)
                    : tierObj.tier_max.slice(-5);
            tierObj.tier_values =
                tierObj.tier_values.length - position >= 5
                    ? tierObj.tier_values.slice(position, position + 5)
                    : tierObj.tier_values.slice(-5);
        }
        return [tierObj, zeroIndexTier];
    }
    function updateBarTier(tierObj,is_quantity_total) {
        let cartObject = globalFieldsSubtotalCartPage_AC.cartObj;
                if (globalFieldsSubtotalCartPage_AC.cartObj.items.length == 0) {
            jQuery('.CartDrawer').remove()
            jQuery('.mainCartDiscount').remove()
            return
        }
        let actualTotalCart = 0;
        let allVariantItemQty = 0
        for (let km = 0; km < cartObject.items.length; km++) {
            allVariantItemQty += cartObject.items[km].quantity;
            actualTotalCart += cartObject.items[km].original_line_price / 100;
        }
        if (is_quantity_total) {
                actualTotalCart =allVariantItemQty
            } 
        let barCountsCart = document.querySelectorAll(".barCounts-Cart");
        let barCountsDrawer = document.querySelectorAll(".barCounts-Drawer");
        barCountsCart.forEach((step) => step.classList.remove("active-Cart"));
        barCountsDrawer.forEach((step) => step.classList.remove("active-Drawer"));
        for (let i = 0; i < tierObj.tier_min.length; i++) {
            let tierValue =
                tierObj.discount_type === "percentage"
                    ? `${tierObj.tier_values[i]}% OFF`
                    : `${globalFieldsSubtotal.formatMoney(tierObj.tier_values[i] * 100, globalFieldsSubtotal.amount)}`;
        }
        jQuery(".ac-label-cart-discount").prepend(
            `<span class="icon-circle icon-cart-circle"><i class="ri-price-tag-3-line"></i></span>`
        );
        jQuery(".ac-label-Drawer").prepend(`<span class="icon-circle"><i class="ri-price-tag-3-line"></i></span>`);
        let nextTierFound = !1;
        if (tierObj.tier_min.length > 1) {
            for (let i = 0; i < tierObj.tier_min.length; i++) {
                const minAmount = parseFloat(tierObj.tier_min[i]);
                const maxAmount = tierObj.tier_max[i] === "max" ? Infinity : parseFloat(tierObj.tier_max[i]);
                const nextTierMin = i + 1 < tierObj.tier_min.length ? parseFloat(tierObj.tier_min[i + 1]) : null;
                if (actualTotalCart >= minAmount && actualTotalCart <= maxAmount && !nextTierFound) {
                    const remainingAmount = nextTierMin ? nextTierMin - actualTotalCart : 0;
                    if (actualTotalCart != 0) {
                        let tempBarCounts = globalFieldsSubtotal.isCartPage ? barCountsCart : barCountsDrawer
                        let tempClass = globalFieldsSubtotal.isCartPage ? "active-Cart" : "active-Drawer"
                        tempBarCounts[i].classList.add(tempClass);
                        const widthPercentage = ((actualTotalCart - minAmount) / (maxAmount - minAmount)) * 100;
                        tempBarCounts[i].style.width = `${35}%`;
                    }
                    if (remainingAmount > 0) {
                    } else {
                    }
                    nextTierFound = !0;
                } else if (!nextTierFound && actualTotalCart < minAmount) {
                    const remainingAmount = minAmount - actualTotalCart;
                    if (actualTotalCart != 0) {
                        let tempBarCounts = globalFieldsSubtotal.isCartPage ? barCountsCart : barCountsDrawer
                         let tempClass = globalFieldsSubtotal.isCartPage ? "active-Cart" : "active-Drawer"
                        tempBarCounts[i].classList.add(tempClass);
                        const widthPercentage = (actualTotalCart / minAmount) * 100;
                        tempBarCounts[i].style.width = `${35}%`;
                    }
                    nextTierFound = !0;
                }
            }
        }
    }
    var SetCookie = function (cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };
        let checkData = globalFieldsSubtotalCartPage_AC.cartSubTotalMetafield;
window.onload = function() {
    if (checkData && checkData.status && globalFieldsSubtotal.StartEndDateValid(checkData.start_date, checkData.end_date) && checkData.tier_min.length > 1) {
        // addProgresbarHtml();
        TieredPricingCart(globalFieldsSubtotalCartPage_AC.cartObj, !0);
    }
};
        

    if (checkData && checkData.status && globalFieldsSubtotal.StartEndDateValid(checkData.start_date, checkData.end_date) && checkData.tier_min.length > 1) {
        addProgresbarHtml();
    }

    TieredPricingCart(globalFieldsSubtotalCartPage_AC.cartObj, !0);
    CheckoutClickCart();
    CheckoutClickAjax();
};
var globalFieldsSubtotalCartPage_AC = new ACDiscountAppSubTotal.CartPage.Global();
var cartObject = new ACDiscountAppSubTotal.CartPage.Show_CalculateTier();
